import {
	PROMOTION_LIST,
	PROMOTION_LIST_SUCCESS,
	PROMOTION_LIST_ERROR,
	PROMOTION_SAVE,
	PROMOTION_SAVE_SUCCESS,
	PROMOTION_SAVE_ERROR,
	PROMOTION_DELETE,
	PROMOTION_DELETE_SUCCESS,
	PROMOTION_DELETE_ERROR,
} from '../actions-registry';

const INIT_STATE = {
	list: [],
	loading: false,
	saving: false,
};

export default (state = INIT_STATE, action) => {
	switch (action.type) {
		case PROMOTION_LIST:
			return { ...state, loading: true };
		case PROMOTION_LIST_SUCCESS:
			return { ...state, loading: false, list: action.payload };
		case PROMOTION_LIST_ERROR:
			return { ...state, loading: false };

		case PROMOTION_SAVE:
			return { ...state, saving: true };
		case PROMOTION_SAVE_SUCCESS:
			return { ...state, saving: false };
		case PROMOTION_SAVE_ERROR:
			return { ...state, saving: false };

		case PROMOTION_DELETE:
			return { ...state, saving: true };
		case PROMOTION_DELETE_SUCCESS:
			return { ...state, saving: false };
		case PROMOTION_DELETE_ERROR:
			return { ...state, saving: false };

		default:
			return { ...state };
	}
};
